// sortByField and unique
export function sortByField<T>(data: T[], field: keyof T, unique = false, descending = false): T[] {
	const r = descending ? -1 : 1;  // used to reverse (-1, 0, +1) ordering
	const sorted = data
		.sort((a, b) => r * ((a[field] < b[field]) ? -1 : ((a[field] > b[field]) ? 1 : 0)));  // sort
	return !unique ? sorted :
		sorted.filter((v, i, A) => i === 0 || v[field] !== A[i - 1][field]);  // unique
}

export function range(n: number) {
	return Array.from(Array(n).keys());  // [0, 1, 2, ..., n-1]
}


// Generic types
export type HashMap<T = string> = { [key: string]: T };
export type NumHashMap<T = string> = { [key: number]: T };
export type KeyHashMap<K, T = string> = Partial<{ [P in keyof K]: T }>;
export type EnumHashMap<E extends string, T = string> = { [P in E]?: T };


// formatting

// Like "Jan 22"
export function formatDateShort(date: Date | string) {
	const d = typeof date === 'string' ? new Date(date) : date;
	const t = d.toUTCString();  // Date as in UTC
	const p = t.substring(5).split(' ');
	return `${p[1]} ${p[2].substring(2, 4)}`;
}

// Like "Fri, Jan 15 2022"
export function formatDate(date: Date | string, omitYear = false) {
	const d = typeof date === 'string' ? new Date(date) : date;
	const t = d.toUTCString().substring(0, 16);  // Local timezone
	return omitYear ? t.substring(0, t.length - 5) : t;
}

// Like "Fri Feb 07 2025 at 08:25:53"
export function formatDateTimeLocalTZ(ts: Date | string) {
	const t = typeof ts === 'string' ? new Date(ts) : ts;
	return t.toDateString() + ' at ' + t.toLocaleTimeString();  // Local timezone
}

// Init a JS date and add minutes fo that even in Argentina 2024-10-01 is not end of September
export function initJSDateCompensatingLocalTimeZone(date: string) {
	const d = new Date(date);
	const offsetMinutes = 1 + d.getTimezoneOffset();
	d.setTime(d.getTime() + offsetMinutes * 60 * 1000);
	return d;
}
